import axios from "axios";

//IMPORT API ROUTE URL
import { GET_RECOMMENDATION_ROUTE } from "./apiRoutes";

const getRecommendations = (resourceSlug) => {
  var postData = new FormData();

  postData.append("resource_slug", resourceSlug);

  return axios
    .post(GET_RECOMMENDATION_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getRecommendations;
